import React from 'react';

import SixteenNineIframe from './sixteen-nine-iframe';
import { getVideoUrl } from '../../lib/utils';

interface VideoComponentProps {
  url: string;
  accessibilityText?: string;
  containerClass: string;
  iframeId: string;
  testId?: string;
  allowFullScreen?: boolean;
}

const VideoComponent = ({
  url,
  accessibilityText,
  containerClass,
  iframeId,
  testId,
  allowFullScreen = true
}: VideoComponentProps): React.ReactElement | null => {
  const videoUrl = getVideoUrl(url);
  return (
    <SixteenNineIframe
      src={videoUrl}
      title={accessibilityText}
      id={iframeId}
      containerClass={containerClass}
      testId={testId}
      allowFullScreen={allowFullScreen}
    />
  );
};

export default VideoComponent;
